import { render, staticRenderFns } from "./IconBike.vue?vue&type=template&id=f95a610c"
import script from "./IconBike.vue?vue&type=script&lang=js"
export * from "./IconBike.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports